var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaalhytte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.529,12.786l-.715-.174.513-.13a.5.5,0,0,0-.246-.97l-2.341.594-2.442-.6a.5.5,0,0,0-.237.972l.61.148-.615.156a.5.5,0,0,0,.124.985.524.524,0,0,0,.123-.015l2.442-.62,2.548.621a.476.476,0,0,0,.118.014.5.5,0,0,0,.118-.986Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2,11.582a1.927,1.927,0,0,0,1.16-.543,2.247,2.247,0,0,0,.6-1.151,3.055,3.055,0,0,0-.293-1.9,6.126,6.126,0,0,0-.943-1.4c-.35-.442-1.312-1.656-1.567-1.506-.057.033-.051.118-.062.257a3.661,3.661,0,0,1-.44,1.2c-.415.873-.543.875-.87,1.591a3.039,3.039,0,0,0-.416,1.42,2.118,2.118,0,0,0,.416,1.225c.408.532,1.175.879,1.244.794S6.57,11.2,6.5,10.6a1.986,1.986,0,0,1,.172-.918,3.686,3.686,0,0,0,.257-.563c.087-.288-.07-.566-.019-.574.281-.044.377,1.056.514,1.053.16,0,.294-.584.343-.992.093-.785-.091-1.275.049-1.334s.211.423.382.665A3.325,3.325,0,0,1,8.924,9.5,2.252,2.252,0,0,1,8.8,10.725C8.566,11.27,8.149,11.511,8.2,11.582Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.669,5.221,8.053,1.854a.5.5,0,0,0-.514,0L1.922,5.221a.5.5,0,0,0,.257.929.489.489,0,0,0,.256-.072L7.8,2.866l5.359,3.212a.5.5,0,1,0,.514-.857Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaalhytte);
export default __webpack_public_path__ + "static/media/BAALHYTTE.a201aef971d9bcdb6c153664d6d9a831.svg";
export { ForwardRef as ReactComponent };